import React, { Component } from 'react'
import { dtLangConfig } from "../../../../config/dtLangConfig";
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import moment from 'moment';
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const $ = require('jquery');

$.DataTable = require('datatables.net-bs4');

export class Table extends Component {

    componentDidMount() {
        this.$el = $(this.el)
        this.$el.DataTable({ language: dtLangConfig })
    }

    shouldComponentUpdate() {
        this.$el.DataTable().destroy();
        return true
    }

    componentDidUpdate() {
        this.$el.DataTable({ language: dtLangConfig })
    }

    componentWillUnmount() {
        this.$el.DataTable().destroy(true);
    }

    onClickEliminar(e, empresaId) {
        e.preventDefault()
        this.props.onClickEliminar(empresaId)
    }

    onClickEditar(e, empresaId) {
        e.preventDefault()
        this.props.onClickEditar(empresaId)
    }

    render() {

        return (
            <div className="col-12">
                <div className="card shadow">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table id="dataTable" className="dataTable table" width="100%" cellSpacing="0" ref={el => this.el = el}>
                                <thead>
                                    <tr>
                                        <th>Título Publicación</th>
                                        <th>Categoría Principal</th>
                                        <th>Etiquetas</th>
                                        <th>Fecha de publicación</th>
                                        <th>Estado</th>
                                        <th className="text-center">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                        {Array.from(this.props.data).map((post, index) => {
                                         return <tr key={index}>
                                            <td>
                                                {post.nm_titulo}
                                            </td>
                                            <td>
                                                {post.id_categoria && post.id_categoria.nm_categoria}
                                            </td>
                                            <td>
                                                {post.id_etiqueta.map((etiqueta, index) => {
                                                    return <span key={index} className="badge badge-info mr-1">{etiqueta.nm_etiqueta}</span>
                                                })}
                                            </td>
                                            <td>
                                                {post.fc_publicacion ? moment(post.fc_publicacion).format('DD-MM-YYYY HH:mm') : ""}
                                            </td>
                                            <td className={post.id_estado === 'Publicado' ? 'text-success' : 'text-danger'}>
                                                {post.id_estado}
                                            </td>
                                            <td className="text-center">
                                                <FontAwesomeIcon role="button" tabIndex="0" title="Editar Publicación" className="fas fa-pen mr-3 text-success" icon={faPen} onClick={(e) => this.onClickEditar(e, post)} />
                                                <FontAwesomeIcon role="button" tabIndex="0" title="Eliminar Publicación" className="fa fa-trash text-danger" icon={faTrash} onClick={(e) => this.onClickEliminar(e, post)} />
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

